import { useNavigate } from 'react-router-dom';
import Button from '../common/Button';
import './LandingPage.css';

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing">
      <div className="landing__content">
        <h1 className="landing__title">인스펙터 RAG 시스템</h1>
        <p className="landing__subtitle">AI 기반 문서 검색 및 질의응답 시스템</p>
        <Button onClick={() => navigate('/demo')}>데모 보기</Button>
      </div>
    </div>
  );
}

export default LandingPage;
